import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=0622acc6&scoped=true"
import script from "./BaseDivider.vue?vue&type=script&lang=js"
export * from "./BaseDivider.vue?vue&type=script&lang=js"
import style0 from "./BaseDivider.vue?vue&type=style&index=0&id=0622acc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622acc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0622acc6')) {
      api.createRecord('0622acc6', component.options)
    } else {
      api.reload('0622acc6', component.options)
    }
    module.hot.accept("./BaseDivider.vue?vue&type=template&id=0622acc6&scoped=true", function () {
      api.rerender('0622acc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ui/atoms/baseDivider/BaseDivider.vue"
export default component.exports